import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../../assets/images/closeIconModal.svg";
import CellTab from "../../../../assets/images/Cell Tab.png";
import Timer from "../../../../assets/images/timer.png";
import Warning from "../../../../assets/images/warning-2.png";
import Cell1 from "../../../../assets/images/Cell Tab (1).png";
import Cell2 from "../../../../assets/images/ticket-expired.png";
import Cell3 from "../../../../assets/images/Cell Tab (3).png";

const reasons = [
    { img: CellTab, text: "Product NA" },
    { img: Timer, text: "Sourcing Delay" },
    { img: Warning, text: "Damage Item" },
    { img: Cell1, text: "Duplicate Order" },
    { img: Cell2, text: "Price Issue" },
    { img: Cell3, text: "Too Busy" }
];

interface ReasonModalProps {
    show: boolean;
    onCloseClick: (value: boolean) => void;
    onSubmit: () => void;
    selectedReason: string;
    setSelectedReason: (reason: string) => void;
}

const ReasonModal: React.FC<ReasonModalProps> = ({ show, onCloseClick, onSubmit, selectedReason, setSelectedReason }) => {
    return (
        <Modal isOpen={show} centered={true} className="reasonModl">
            <ModalBody className="modal_Body">
                <img
                    data-testing-id="closeIcon"
                    onClick={() => onCloseClick(false)}
                    className='closeIconModal'
                    src={CLoseImg}
                    alt=""
                />
                <div className="mainDv">
                    <h1>Reasons?</h1>
                    <div className="allContent">
                        {reasons.map((reason, index) => (
                            <div key={index} data-testing-id={"itemDv_reason" + index} className={`contDv ${selectedReason === reason.text ? "selected" : ""}`}
                                onClick={() => setSelectedReason(reason.text)}>
                                <img src={reason.img} alt={reason.text} />
                                <h6>{reason.text}</h6>
                            </div>
                        ))}
                    </div>
                    <div className="btnDv">
                        <button type="button" data-testing-id="submintBtn_reason" onClick={onSubmit} disabled={!selectedReason}>Submit</button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

ReasonModal.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    setSelectedReason: PropTypes.func.isRequired
};

export default ReasonModal;
